import { render, staticRenderFns } from "./footerExternal.vue?vue&type=template&id=c04a9f60&scoped=true&name=footerExternal&"
import script from "./footerExternal.vue?vue&type=script&lang=js&"
export * from "./footerExternal.vue?vue&type=script&lang=js&"
import style0 from "./footerExternal.vue?vue&type=style&index=0&id=c04a9f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04a9f60",
  null
  
)

export default component.exports